import React from "react";
import { useSelector } from "react-redux";
import { hasPermission, isSuperAdmin, PERMISSIONS, ROLES } from "../../utils/permissionManager";

/**
 * Conditionally render components or buttons based on user permissions
 * @param {string|string[]} permission - Single permission or array of permissions (requires at least one)
 * @param {React.ReactNode} children - Content to render if permitted
 * @param {React.ReactNode} [fallback=null] - Fallback to render if not permitted
 */
export const HasPermission = ({ permission, children, fallback = null }) => {
  const { user } = useSelector((state) => state.auth);

  if (!user) return fallback;
  return hasPermission(user, permission) ? children : fallback;
};

/**
 * Pure helper function to check permissions
 */
export const checkUserPermission = (user, permission) => {
  return hasPermission(user, permission);
};

export { hasPermission, isSuperAdmin, PERMISSIONS, ROLES };
export default HasPermission;
